// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"Chart--next-sr-only--Q9QvVve","FilterTitle":"Chart--FilterTitle--3UfN19o"};